import { ChangeDetectionStrategy, Component, inject, signal } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatCard, MatCardActions, MatCardContent } from "@angular/material/card";
import { MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { Router } from "@angular/router";
import { AuthService } from "@auth0/auth0-angular";

@Component({
    selector: "session-expired-dialog",
    templateUrl: "./session-expired-dialog.component.html",
    styleUrl: "./session-expired-dialog.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MatProgressSpinnerModule,
        MatCard,
        MatCardContent,
        MatCardActions,
    ],
})
export class SessionExpiredDialogComponent {
    private auth = inject(AuthService);
    private router = inject(Router);
    private dialogRef = inject(MatDialogRef<SessionExpiredDialogComponent>);

    loading = signal(false);

    login(): void {
        this.loading.set(true);
        this.auth.loginWithPopup().subscribe({
            next: () => {
                this.loading.set(false);
                this.dialogRef.close(true);
            },
            error: () => {
                this.loading.set(false);
                // Popup was blocked or closed without login — redirect with return URL so user lands back here
                const returnUrl = this.router.url;
                this.auth.loginWithRedirect({
                    appState: { target: returnUrl },
                    authorizationParams: { prompt: "login" },
                });
                this.dialogRef.close(false);
            },
        });
    }
}
